export default __webpack_public_path__ + "static/media/IconDesc_AILimiter.256.8b984651.png";